// extracted by mini-css-extract-plugin
export default {"file":"upload_file__zMDsi"};